<template>
  <v-container>
    <v-row>
      <v-col cols="9">
        <QCPhotoFilter :initial-filter="photoFilter" @apply-filters="setPhotoFilters($event)"></QCPhotoFilter>
      </v-col>
    </v-row>
    <v-progress-circular v-if="isLoading" indeterminate></v-progress-circular>

    <PhotoListView :images="photos" :isQc="true"/>

    <v-container v-if="photos.length>0" class=" fixed border--primary">
      <v-btn
          class="mr-2 float-right"
          color="success"
          @click="submitBatch({getNext: true})">Mark Reviewed & get Next Batch
      </v-btn>
      <v-btn
          class="mr-2 float-right"
          color="primary"
          @click="submitBatch({getNext: false})">Mark Reviewed & Close
      </v-btn>
    </v-container>

  </v-container>
</template>

<script>
import {SURFACES, buildPayload} from '@/components/filters/capabilities'
import PhotoListView from "@/components/PhotoListView";
import QCPhotoFilter from '@/components/filters/QCPhotoFilter'
import axios from "axios";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: 'QualityControl',
  components: {
    QCPhotoFilter,
    PhotoListView,
  },
  data() {
    return {
      categories: [],
      selectedItems: [],
      fromDateVal: '',
      toDateVal: '',
      photoFilter: {
        fromDt: null,
        thruDt: null,
        tags: [],
        projects: [],
        jobs: [],
        taggers: [],
        respIdSearchFreeForm: null,
        onlyNeedsReview: false,
        showQCed: false,
        includeInactive: false,
        country: null,
        retailer: null,
        department: null,
      },
      isLoading: false,
    }
  },
  mounted() {
    this.setQCPhotos([])
    this.getPhotos()
  },
  computed: {
    ...mapState({
      photos: state => state.photos.qcPhotos
    })

  },
  methods: {
    ...mapActions(['submitQCAssigned']),
    ...mapMutations(['setMessage', 'setQCPhotos',]),
    getPhotos: function () {
      let self = this
      self.setQCPhotos([])
      self.isLoading = true
      // IT-707 P2.1: key names and coercion come from the shared capability
      // builder; this view keeps its own transport and response handling.
      let payload = buildPayload(SURFACES.PHOTO_QC, this.photoFilter)

      return axios.post('/api/photos/quality_control/', payload)
          .then(response => {
            self.isLoading = false
            self.setQCPhotos(response.data)

          })
          .catch(error => {
            self.isLoading = false
            console.log(error)
          })
    },
    setPhotoFilters: function (newFilter) {
      this.photoFilter = newFilter
      this.getPhotos()
    },
    submitBatch(payload) {
      let self = this
      this.submitQCAssigned().then(() => {
        self.setMessage({
          text: 'Photos Marked Reviewed',
          type: 'success',
          alert: true
        })
        self.setQCPhotos([])
        if (payload.getNext) {
          self.getPhotos()
        }
      })
    },
  }
}
</script>

<style>
</style>
